<template>
  <div class="lg:mt-10 md:mt-9 mt-5 lg:flex md:flex gap-2">
    <div class="container">
      <h2 class="fsize32 text4F0A4B text-left capitalize">
        <b>Principals</b> of Palliative Care
      </h2>
      <p class="fsize16 text-dark">
        The three common principles of palliative care are:
      </p>
      <div
        class="w-full grid lg:grid-cols-3 md:grid-cols-2 grid-cols-1 gap-4 mt-8"
      >
        <div>
          <img
            src="https://nimbus-server-01.brained.in/nimbus-server-01/caregiversaathi/palliative-care/Relief%20of%20Pain%20and%20Other%20Symptoms.jpg"
            alt="relief of pain and other symptoms"
            class="patient-img object-cover"
          />
          <h2
            class="fsize16 text-dark text-center mt-3 capitalize font-semibold"
          >
            Relief of Pain and Other Symptoms
          </h2>
          <p class="fsize13 mt-2 text-center">
            The primary goal of palliative care is to relieve the pain and other
            symptoms associated with a serious illness. This includes physical
            symptoms such as pain, nausea, and shortness of breath, as well as
            emotional symptoms such as anxiety and depression.
          </p>
        </div>
        <div>
          <img
            src="https://nimbus-server-01.brained.in/nimbus-server-01/caregiversaathi/palliative-care/Communication%20and%20Shared%20Decision%20Making.jpg"
            alt="communication and shared decision making"
            class="patient-img object-cover"
          />
          <h2
            class="fsize16 text-dark text-center mt-3 capitalize font-semibold"
          >
            Communication and Shared Decision Making
          </h2>
          <p class="fsize13 mt-2 text-center">
            Palliative care involves open and honest communication between
            healthcare providers, patients, and their families. Patients and
            their families are involved in decision making about their care,
            including the setting of goals and the development of a care plan.
          </p>
        </div>
        <div>
          <img
            src="https://nimbus-server-01.brained.in/nimbus-server-01/caregiversaathi/palliative-care/Holistic%20Care.jpg"
            alt="holistic care"
            class="patient-img object-cover"
          />
          <h2
            class="fsize16 text-dark text-center mt-3 capitalize font-semibold"
          >
            Holistic Care
          </h2>
          <p class="fsize13 mt-2 text-center">
            Palliative care takes a holistic approach to care, addressing the
            physical, emotional, social, and spiritual needs of the patient and
            their family. This includes providing support for patients and their
            families throughout the course of the illness and helping them to
            cope with the challenges that arise.
          </p>
        </div>
      </div>
      <h2 class="fsize32 text4F0A4B text-left capitalize mt-8">
        <b>7c’s Framework</b> for Palliative Care
      </h2>
      <p class="fsize16 text-dark">
        The 7 Cs framework provides a comprehensive approach to the provision of
        quality palliative care. The 7 Cs stand for: 
      </p>
      <div class="mt-4">
        <ul class="list-dec ml-6">
          <li class="fsize16 text-dark pb-2">
            <b>Communication:</b> Effective communication is essential in
            palliative care. This includes clear and honest discussions about
            the patient's diagnosis, prognosis, treatment options, and goals of
            care. 
          </li>
          <li class="fsize16 text-dark pb-2">
            <b>Coordination:</b> Palliative care involves a team-based approach
            to care. Effective coordination among healthcare professionals,
            patients, and families is critical to ensuring that patients receive
            comprehensive care that is aligned with their needs and
            preferences. 
          </li>
          <li class="fsize16 text-dark pb-2">
            <b>Control of symptoms:</b> Palliative care aims to alleviate
            symptoms and improve the quality of life for patients. Effective
            symptom management requires a holistic approach that addresses
            physical, psychological, social, and spiritual needs. 
          </li>
          <li class="fsize16 text-dark pb-2">
            <b>Continuity of care:</b> Palliative care is an ongoing process
            that requires continuity of care across different settings,
            including hospitals, hospices, and home care. Effective coordination
            and communication among healthcare professionals is essential to
            ensure that patients receive seamless care as they move between
            different settings. 
          </li>
          <li class="fsize16 text-dark pb-2">
            <b>Compassionate care:</b> Palliative care is based on a philosophy
            of compassionate care. This involves providing care that is
            respectful, empathetic, and sensitive to the unique needs and
            preferences of each patient.
          </li>
          <li class="fsize16 text-dark pb-2">
            <b>Cultural competence:</b> Palliative care should be provided in a
            culturally sensitive manner that respects the beliefs, values, and
            preferences of patients and families from diverse cultural
            backgrounds.
          </li>
          <li class="fsize16 text-dark pb-2">
            <b>Counseling and support:</b> Palliative care involves providing
            emotional and psychological support to patients and families. This
            may include counseling, support groups, and other forms of
            psychosocial support.
          </li>
        </ul>
      </div>
      <p class="fsize16 text-dark mt-2">
        Overall, the 7 Cs framework provides a useful guide for healthcare
        professionals in the provision of quality palliative care that is
        patient-centered, compassionate, and holistic. 
      </p>
    </div>
    <!-- <div class="border-left lg:w-2/12 md:w-2/12 w-full lg:mt-0 md:mt-0 mt-4">
      <SideBlogs />
    </div> -->
  </div>
</template>
<script>
import SideBlogs from "./components/SideBlogs.vue";
export default {
  components: {
    SideBlogs,
  },
};
</script>
<style>
.patient-img {
  border-radius: 10px;
  height: 200px;
  width: 100%;
}
.list-dec {
  list-style: decimal;
}
</style>
